'use client'

import { Button, ButtonProps, Modal } from 'flowbite-react'
import Link from 'next/link'
import { useState } from 'react'

export interface FormFooterCancelProps extends Omit<ButtonProps, 'type'> {
  cancelUrl: string
  showConfirm: boolean
  confirmText?: React.ReactNode
  leaveButtonText?: string
}

export const FormFooterCancel = ({
  cancelUrl,
  showConfirm,
  confirmText = <>Leave this page without saving your changes?</>,
  leaveButtonText = 'Yes, leave form',
  color = 'light',
  children = <>Cancel</>,
}: FormFooterCancelProps) => {
  const [isOpenConfirmModal, setisOpenConfirmModal] = useState(false)

  return (
    <>
      <Modal
        show={isOpenConfirmModal}
        size="md"
        onClose={() => setisOpenConfirmModal(false)}
        popup
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="w-full mb-4 text-center text-base font-normal text-gray-500 dark:text-gray-400">
              {confirmText}
            </div>
            <div className="flex justify-center gap-4">
              <Button
                color="light"
                onClick={() => setisOpenConfirmModal(false)}
                className="w-full"
              >
                No, cancel
              </Button>
              <Button
                color="failure"
                as={Link}
                href={cancelUrl}
                className="w-full"
              >
                {leaveButtonText}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {showConfirm ? (
        <Button
          type="button"
          color={color}
          onClick={() => setisOpenConfirmModal(true)}
        >
          {children}
        </Button>
      ) : (
        <Button type="button" color={color} as={Link} href={cancelUrl}>
          {children}
        </Button>
      )}
    </>
  )
}
